// как кастомизировать компоненты: https://wiki.yandex.ru/site/problemy-i-reshenija/ant-design/customize-ant-design-components/
// подробно (в конце статьи): https://betterprogramming.pub/ant-design-system-dark-mode-and-other-theme-customization-fa4ff14359a4
// дизайн темы https://ant.design/theme-editor

import { theme } from '../theme_data'


export const antd_theme = {
  token: {
    colorTextBase: theme.cDarkText,
    colorPrimary: theme.antdMainColor,
    borderRadius: parseInt(theme.borderRadius),
    fontSize: parseInt(theme.input_text_size),
    fontFamily: theme.fontFamilyBase,
    controlHeight: 44,
    colorBorder: theme.input_border_color,
    colorIcon: theme.cLinkLightBlue,
    colorIconHover: theme.cLinkLightBlue,
    colorLink: theme.cLinkLightBlue,
    colorLinkActive: theme.cLinkLightBlue,
    colorLinkHover: theme.cLinkLightBlue,
    colorTextPlaceholder: theme.input_placeholder_color,
    colorTextLabel: theme.cGreyText,
    colorTextHeading: theme.cGreyText,
    colorTextDisabled: theme.cGreyText,
    colorError: theme.colorError,
    colorErrorHover: theme.colorError,
    controlOutlineWidth: 1,
  },
  components: {
    Button: {
      borderRadius: 10,
      controlHeight: 46,
      fontWeight: 600,
      colorPrimary: theme.cOrange,
      paddingContentHorizontal: 35,
      colorTextDisabled: theme.cWhite,
      colorBgContainerDisabled: theme.disabled_color,
      borderColorDisabled: "transparent",
    },
    Tooltip: {
      colorTextLightSolid: theme.cTextColor,
      colorBgDefault: theme.cWhite,
      colorBgSpotlight: theme.cWhite,
      fontSize: 13,
    },
    Modal: {
      colorText: theme.cSuperBlack,
      colorTextHeading: theme.cSuperBlack,
      titleFontSize: 15,
      fontSizeHeading5: 15,
      colorBgDefault: theme.cWhite,
      fontSize: 15,
      padding: 0,
      paddingXS: 0,
      paddingMD: 0,
      paddingLG: 0,
      paddingContentHorizontalXS: 0,
      paddingContentHorizontalMD: 0,
      paddingContentHorizontalLG: 0,
    },
    Drawer: {
      colorText: theme.cSuperBlack,
      colorTextHeading: theme.cSuperBlack,
      titleFontSize: 15,
      fontSizeHeading5: 15,
      colorBgDefault: theme.cWhite,
      fontSize: 15,
      padding: 0,
      paddingXS: 0,
      paddingMD: 0,
      paddingLG: 0,
      paddingContentHorizontalXS: 0,
      paddingContentHorizontalMD: 0,
      paddingContentHorizontalLG: 0,
    },
    Checkbox: {
      controlInteractiveSize: 18
    },
    Cascader: {
      menuPadding: 0,
    },
    Tabs: {
      margin: 20,
      horizontalItemGutter: 14,
      horizontalItemPadding: '14px 8px',
      inkBarColor: theme.cOrange,
      itemSelectedColor: theme.cDarkText,
      itemHoverColor: theme.cOrange,
    },
  },
};

export const primary_button = {
  token: {
    colorPrimaryText: theme.cOrange,
  },
  components: {
    Button: {
      colorPrimary: theme.cOrange
    },
  },
};

export const saved_button = {
  token: {
    colorPrimary: theme.cSuccess,
  },
  components: {
    Button: {
      colorPrimary: theme.cSuccess
    },
  },
};

export const loading_button = {
  token: {
    colorPrimary: theme.cGreyText,
  },
  components: {
    Button: {
      colorPrimary: theme.cGreyText
    },
  },
};

export const disabled_button = {
  token: {
    colorPrimary: theme.cGreyText,
  },
  components: {
    Button: {
      colorTextDisabled: theme.cWhite,
      colorBgContainerDisabled: theme.disabled_color,
      colorBorder: "transparent",
    },
  },
};
